import { render, staticRenderFns } from "./help.vue?vue&type=template&id=68f7f21f&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=68f7f21f&prod&scoped=true&lang=less"
import style1 from "./help.vue?vue&type=style&index=1&id=68f7f21f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7f21f",
  null
  
)

export default component.exports